var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"text-sm rounded-md inline-flex items-center px-2 py-1",class:_vm.variant},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }